// jsdom (jest) makes `window.location` unforgeable, so navigation goes
// through these wrappers and specs mock this module instead of the global.
export function assignLocation(url) {
  window.location.assign(url);
}

export function reloadPage() {
  window.location.reload();
}

function goToUrl(url) {
  document.body.style.cursor = 'wait';
  window.location.href = url;
}

function goToQuiz() {
  goToUrl('/quizzes/');
}

const locationService = {
  goToUrl,
  goToQuiz,
  assignLocation,
  reloadPage,
};

export default locationService;
